/* global SETTINGS:false */
__webpack_public_path__ = `${SETTINGS.public_path}`; // eslint-disable-line no-undef, camelcase

import "jquery";
import "slick-carousel";
import "popper.js";
import "bootstrap";
